import React from "react";

const TOKENS = [
  { re: /```([^`]+)```/g, tag: "code" },
  { re: /\*([^*\n]+)\*/g, tag: "strong" },
  { re: /_([^_\n]+)_/g, tag: "em" },
  { re: /~([^~\n]+)~/g, tag: "s" },
  { re: /`([^`\n]+)`/g, tag: "code" },
];

function applyToken(text, re, tag, prefix) {
  const out = [];
  let lastIndex = 0;
  let match;

  while ((match = re.exec(text))) {
    if (match.index > lastIndex) {
      out.push(text.slice(lastIndex, match.index));
    }
    out.push(React.createElement(tag, { key: `${prefix}-${match.index}` }, match[1]));
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    out.push(text.slice(lastIndex));
  }
  return out;
}

function formatSegment(segment, prefix) {
  if (typeof segment !== "string") return segment;
  let nodes = [segment];
  TOKENS.forEach(({ re, tag }, idx) => {
    nodes = nodes.flatMap((node, nodeIdx) =>
      typeof node === "string"
        ? applyToken(node, new RegExp(re), tag, `${prefix}-${idx}-${nodeIdx}`)
        : [node]
    );
  });
  return nodes;
}

export function renderWhatsAppRichText(text = "") {
  return String(text || "")
    .split("\n")
    .flatMap((line, lineIndex, lines) => {
      const nodes = formatSegment(line, `line-${lineIndex}`);
      if (lineIndex === lines.length - 1) return nodes;
      return [...nodes, React.createElement("br", { key: `br-${lineIndex}` })];
    });
}
